module.exports = __webpack_public_path__ + "static/media/destinationRight.26912142.svg";